import axiosInstance from "../../api/axios";
import { ProductRequest } from "../../types/product";

// Get Product
export const getProduct = async (status?: string) => {
  try {
    const res = await axiosInstance.get(`/product/list/`, {
      params: {
        status,
      },
    });
    return { success: true, data: res.data };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.message || "Failed to fetch product.",
    };
  }
};

export const createProduct = async (data: ProductRequest) => {
  try {
    const response = await axiosInstance.post(`/product/`, data);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

export const updateProduct = async (id: number, data: ProductRequest) => {
  try {
    const res = await axiosInstance.put(`/product/${id}`, data);
    return { success: true, data: res.data };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.message || "Failed to update product.",
    };
  }
};

export const getProductById = async (id: number) => {
  try {
    const res = await axiosInstance.get(`/product/${id}`);
    return { success: true, data: res.data };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.message || "Failed to fetch product.",
    };
  }
};

export const deleteProduct = async (id: number) => {
  try {
    const response = await axiosInstance.delete(`/product/${id}`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.message || "Failed to delete product",
    };
  }
};